import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectQueueActiveProfile,
    selectQueueEditable,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import ActiveProfile from '../ActiveProfile';

interface Props {
    queueKey: QueueKey;
}

const QueueActiveProfile = ({ queueKey }: Props) => {
    const isEditable = useAppSelector((state) =>
        selectQueueEditable(state, queueKey),
    );
    const activeProfile = useAppSelector((state) =>
        selectQueueActiveProfile(state, queueKey),
    );

    return (
        <ActiveProfile
            entityKey={queueKey}
            isEditable={isEditable}
            routeKey="pbx.queues.entityKey.profiles"
            activeProfile={activeProfile}
        />
    );
};

export default QueueActiveProfile;
